var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lanshou_box" }, [
    _vm._m(0),
    _c("div", { staticClass: "lanshou_title" }, [
      _c("div", { staticStyle: { flex: "1" } }),
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("RouterObj.pickupServiceDashboard"))),
      ]),
      _c("div", { staticClass: "title_time" }, [
        _c("div", { staticStyle: { "max-width": "260px" } }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("GlobalSetObj.UpdateTime")) +
              "：" +
              _vm._s(_vm.updateTime) +
              " "
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "lanshou_search" },
      [
        _c(
          "el-form",
          { attrs: { size: "small", "label-position": "top" } },
          [
            _c(
              "el-row",
              { attrs: { gutter: 10 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("collectionCenter.orderCreateT"),
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            clearable: false,
                            "value-format": "yyyy-MM-dd",
                            placeholder: _vm.$t("operationCenter.PleaseSelect"),
                          },
                          model: {
                            value: _vm.queryForm.queryDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "queryDate", $$v)
                            },
                            expression: "queryForm.queryDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("collectionCenter.businessT") },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            },
                            model: {
                              value: _vm.queryForm.businessType,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "businessType", $$v)
                              },
                              expression: "queryForm.businessType",
                            },
                          },
                          [
                            _c("el-option", {
                              key: "all",
                              attrs: {
                                label: _vm.$t("GlobalSetObj.all"),
                                value: null,
                              },
                            }),
                            _c("el-option", {
                              key: "FM",
                              attrs: { label: "FM", value: "FM" },
                            }),
                            _c("el-option", {
                              key: "SFS",
                              attrs: { label: "SFS", value: "SFS" },
                            }),
                            _c("el-option", {
                              key: "D2D",
                              attrs: { label: "D2D", value: "D2D" },
                            }),
                            _c("el-option", {
                              key: "快递",
                              attrs: {
                                label: _vm.$t(
                                  "collectionCenter.expressDelivery"
                                ),
                                value: "快递",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("collectionCenter.CustomerName"),
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "spareNumberPoo.Only10AreDisplayed"
                              ),
                              "remote-method": _vm.getCustomerPage,
                              filterable: "",
                              remote: "",
                            },
                            on: {
                              "visible-change": function ($event) {
                                return _vm.getCustomerPage()
                              },
                            },
                            model: {
                              value: _vm.queryForm.customerId,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "customerId", $$v)
                              },
                              expression: "queryForm.customerId",
                            },
                          },
                          [
                            _c("el-option", {
                              key: "all",
                              attrs: {
                                label: _vm.$t("GlobalSetObj.all"),
                                value: null,
                              },
                            }),
                            _vm._l(_vm.customerList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.customerAlias +
                                    "(" +
                                    item.username +
                                    ")",
                                  value: item.id,
                                },
                              })
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("el-col", { attrs: { span: 6 } }, [
                  _c(
                    "div",
                    {
                      staticClass: "lanshou_bottom",
                      staticStyle: { "margin-top": "28px" },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "search",
                          attrs: { type: "text", size: "small" },
                          on: { click: _vm.getData },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("GlobalSetObj.search")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "rest",
                          attrs: { type: "text", size: "small" },
                          on: { click: _vm.resetQuery },
                        },
                        [_vm._v(_vm._s(_vm.$t("GlobalSetObj.reset")))]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "lanshou_content" }, [
      _c("div", { staticStyle: { flex: "1" } }, [
        _c("div", { staticClass: "charts_content" }, [
          _c("div", { staticClass: "charts_title_content" }, [
            _c("img", {
              attrs: {
                src: "/static/lanshouScreen/lanshou_smill_title.png",
                width: "100%",
                height: "100%",
              },
            }),
            _c("div", { staticClass: "charts_title" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("collectionCenter.MerchantDataDisplay")) +
                  " "
              ),
            ]),
          ]),
          _c("div", {
            staticStyle: { height: "240px", width: "100%" },
            attrs: { id: "merchantDataDisplay" },
          }),
        ]),
      ]),
      _c("div", { staticStyle: { flex: "1" } }, [
        _c("div", { staticClass: "charts_content" }, [
          _c("div", { staticClass: "charts_title_content" }, [
            _c("img", {
              attrs: {
                src: "/static/lanshouScreen/lanshou_smill_title.png",
                width: "100%",
                height: "100%",
              },
            }),
            _c("div", { staticClass: "charts_title" }, [
              _vm._v(
                " " + _vm._s(_vm.$t("collectionCenter.CollectionLink")) + " "
              ),
            ]),
          ]),
          _c("div", {
            staticStyle: { height: "240px", width: "100%" },
            attrs: { id: "collectionProcess" },
          }),
        ]),
      ]),
      _c("div", { staticStyle: { flex: "1" } }, [
        _c("div", { staticClass: "charts_content" }, [
          _c("div", { staticClass: "charts_title_content" }, [
            _c("img", {
              attrs: {
                src: "/static/lanshouScreen/lanshou_smill_title.png",
                width: "100%",
                height: "100%",
              },
            }),
            _c("div", { staticClass: "charts_title" }, [
              _vm._v(
                " " + _vm._s(_vm.$t("collectionCenter.SigningLink")) + " "
              ),
            ]),
          ]),
          _c("div", {
            staticStyle: { height: "240px", width: "100%" },
            attrs: { id: "signInProcess" },
          }),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "lanshou_content_bottom charts_content" }, [
      _c("div", { staticClass: "charts_title_content" }, [
        _c("img", {
          attrs: {
            src: "/static/lanshouScreen/lanshou_item_title_bg.png",
            width: "100%",
            height: "100%",
          },
        }),
        _c("div", { staticClass: "charts_title" }, [
          _vm._v(" " + _vm._s(_vm.$t("collectionCenter.KPIReached")) + " "),
        ]),
      ]),
      _c("div", { staticStyle: { display: "flex", padding: "30px 20px" } }, [
        _c("div", { staticClass: "lanshou_bottom_item" }, [
          _c(
            "div",
            { staticStyle: { height: "140px", position: "relative" } },
            [
              _c("img", {
                attrs: {
                  src: "/static/lanshouScreen/lanshou_item_bg.png",
                  height: "100%",
                },
              }),
              _c("div", { staticClass: "lanshou_bottom_item_day" }, [
                _vm._v(
                  _vm._s(_vm.kpiAchievement.collectionTimeEfficiency) +
                    _vm._s(_vm.$t("orderCenterCont.days"))
                ),
              ]),
            ]
          ),
          _c("div", { staticClass: "lanshou_bottom_item_title" }, [
            _vm._v(_vm._s(_vm.$t("collectionCenter.CollectionTime"))),
          ]),
        ]),
        _c("div", { staticClass: "lanshou_bottom_item" }, [
          _c(
            "div",
            { staticStyle: { height: "140px", position: "relative" } },
            [
              _c("img", {
                attrs: {
                  src: "/static/lanshouScreen/lanshou_item_bg.png",
                  height: "100%",
                },
              }),
              _c("div", { staticClass: "lanshou_bottom_item_day" }, [
                _vm._v(
                  _vm._s(_vm.kpiAchievement.arrivalTimeEfficiency) +
                    _vm._s(_vm.$t("orderCenterCont.days"))
                ),
              ]),
            ]
          ),
          _c("div", { staticClass: "lanshou_bottom_item_title" }, [
            _vm._v(_vm._s(_vm.$t("collectionCenter.prescriptionArrival"))),
          ]),
        ]),
        _c("div", { staticClass: "lanshou_bottom_item" }, [
          _c(
            "div",
            { staticStyle: { height: "140px", position: "relative" } },
            [
              _c("img", {
                attrs: {
                  src: "/static/lanshouScreen/lanshou_item_bg.png",
                  height: "100%",
                },
              }),
              _c("div", { staticClass: "lanshou_bottom_item_day" }, [
                _vm._v(
                  _vm._s(_vm.kpiAchievement.spMetroArrivalTimeEfficiency) +
                    _vm._s(_vm.$t("orderCenterCont.days"))
                ),
              ]),
            ]
          ),
          _c("div", { staticClass: "lanshou_bottom_item_title" }, [
            _vm._v(
              _vm._s(_vm.$t("collectionCenter.SaoPauloCityMetropolitanArea"))
            ),
          ]),
        ]),
        _c("div", { staticClass: "lanshou_bottom_item" }, [
          _c(
            "div",
            { staticStyle: { height: "140px", position: "relative" } },
            [
              _c("img", {
                attrs: {
                  src: "/static/lanshouScreen/lanshou_item_bg.png",
                  height: "100%",
                },
              }),
              _c("div", { staticClass: "lanshou_bottom_item_day" }, [
                _vm._v(
                  _vm._s(
                    _vm.kpiAchievement.spCountrysideArrivalTimeEfficiency
                  ) + _vm._s(_vm.$t("orderCenterCont.days"))
                ),
              ]),
            ]
          ),
          _c("div", { staticClass: "lanshou_bottom_item_title" }, [
            _vm._v(
              _vm._s(
                _vm.$t("collectionCenter.DeliveryTimeToSaoPauloCountryside")
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "lanshou_bottom_item" }, [
          _c(
            "div",
            { staticStyle: { height: "140px", position: "relative" } },
            [
              _c("img", {
                attrs: {
                  src: "/static/lanshouScreen/lanshou_item_bg.png",
                  height: "100%",
                },
              }),
              _c("div", { staticClass: "lanshou_bottom_item_day" }, [
                _vm._v(
                  _vm._s(_vm.kpiAchievement.otherStatesArrivalTimeEfficiency) +
                    _vm._s(_vm.$t("orderCenterCont.days"))
                ),
              ]),
            ]
          ),
          _c("div", { staticClass: "lanshou_bottom_item_title" }, [
            _vm._v(
              _vm._s(_vm.$t("collectionCenter.DeliveryTimeToOutsideTheState"))
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lanshou_title_bg" }, [
      _c("img", {
        attrs: {
          src: "/static/lanshouScreen/lanshou_title.png",
          width: "100%",
          height: "100%",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }